import type { IFilter } from '@models/Filter'
import type { Page } from '@models/Page'
import type { Projectbetrokkene } from '@models/Projectbetrokkene'
import type { Sort } from '@models/Query'
import type { SearchResults } from '@models/SearchResults'

import { apiClient } from '../../../gateways/api'
import type {
  ContractinstellingenSearch,
  ContractinstellingenSearchFilters,
} from '../types/ContractinstellingenSearch'

export { fetchProjectbetrokkenen, initialState }

const fetchProjectbetrokkenen = async (
  filters: Partial<ContractinstellingenSearchFilters>,
) => {
  const { data } = await apiClient<SearchResults<Projectbetrokkene>>({
    url: '/rest/projectbetrokkene/search',
    method: 'POST',
    data: {
      filters: createFilters(filters),
      skip: 0,
      limit: 1000,
    },
  })

  return data
}

const initialState: {
  data: SearchResults<Projectbetrokkene>
  query: ContractinstellingenSearch['query'] & {
    page?: Page
    sort?: Sort | Record<string, any>
  }
} = {
  data: { count: 0, skip: 0, limit: 25, items: [] },
  query: {
    filters: {
      combi: null,
    },
  },
}

const createFilters = ({
  combi,
}: Partial<ContractinstellingenSearchFilters>) => {
  const filters: IFilter[] = [
    { name: 'projectType', value: 'Aanvraag', operator: 'eq' },
  ]

  if (combi)
    filters.push({
      name: 'verantwoordelijke',
      value: combi,
      operator: 'eq',
    })

  return filters
}
